import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import { Modal } from '@shared/ui/modal/modal';
import { Button } from '@shared/ui/button/button';
import { useProfile } from '@shared/api/useProfile';
import { getNoun } from '@utils/lib/getNoun';
import { useTeacherOffers } from '../../api/use-teacher-offers';
import { useSendPackageOffer } from '../../model/use-send-offer';
import { usePackageOfferModal } from '../../model/use-package-offer-modal';
import s from './package-offer-modal.module.scss';

// Модалка отправки предложения пакета занятий
export const PackageOfferModal = () => {
  const { isOpen, close, modalParams } = usePackageOfferModal();
  const chatId = modalParams?.chatId;

  const { data: profile } = useProfile();
  const teacherSlug = profile?.teacher_slug;
  const { data: offers, isLoading } = useTeacherOffers(teacherSlug, isOpen);
  const sendPackageOffer = useSendPackageOffer(chatId);

  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    setSelectedId(null);
  }, [isOpen]);

  const handleSend = () => {
    const offer = offers?.find((o) => o.id === selectedId);
    if (!offer) return;
    sendPackageOffer({
      offer_id: offer.id,
      title: offer.name || offer.title,
      lessons_count: offer.lessons_count,
      price: offer.price,
    });
    close();
  };

  if (!isOpen) return null;

  const modalStyle = {
    content: {
      width: 'calc(100% - 40px)',
      maxWidth: '420px',
      maxHeight: 'calc(100svh - 40px)',
      padding: '20px',
      overflow: 'auto',
    },
  };

  return (
    <Modal {...{ isOpen, close }} title="Предложить пакет" style={modalStyle}>
      <motion.div
        className={s.card}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25, ease: 'easeInOut' }}
      >
        {isLoading ? (
          <div className={s.sectionCard}>
            <span className={s.empty}>Загрузка…</span>
          </div>
        ) : offers?.length > 0 ? (
          <div className={s.sectionCard}>
            <h3 className={s.sectionTitle}>Ваши пакеты</h3>
            <div className={s.offers}>
              {offers.map((offer) => (
                <button
                  key={offer.id}
                  type="button"
                  className={classNames(s.offer, selectedId === offer.id && s.active)}
                  onClick={() => setSelectedId(offer.id)}
                >
                  <span className={s.radio}>
                    {selectedId === offer.id && <span className={s.radioDot} />}
                  </span>
                  <span className={s.offerInfo}>
                    <span className={s.offerTitle}>
                      {offer.name || offer.title || 'Пакет занятий'}
                    </span>
                    {offer.lessons_count && (
                      <span className={s.offerSubtitle}>
                        {offer.lessons_count}{' '}
                        {getNoun(offer.lessons_count, 'занятие', 'занятия', 'занятий')}
                      </span>
                    )}
                  </span>
                  {offer.price && (
                    <span className={s.offerPrice}>
                      {Number(offer.price).toLocaleString('ru-RU')} ₽
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>
        ) : (
          <div className={s.sectionCard}>
            <span className={s.empty}>У вас нет активных пакетов для предложения</span>
          </div>
        )}
        <div className={s.footer}>
          <Button
            label="Отправить предложение"
            onClick={handleSend}
            disabled={!selectedId}
            className={s.submitBtn}
          />
        </div>
      </motion.div>
    </Modal>
  );
};
